import { render, staticRenderFns } from "./MailAccountForm.vue?vue&type=template&id=10121d2e&"
import script from "./MailAccountForm.vue?vue&type=script&lang=js&"
export * from "./MailAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./MailAccountForm.vue?vue&type=style&index=0&id=10121d2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports